export default __webpack_public_path__ + "static/media/NewBanners_amazon500_gmm_330x330.e6f467d2.png";